import { convertToRaw, EditorState, ContentState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { useSelector } from 'react-redux';
import * as tribunalAPI from '@debbie/cortex/dist/api/tribunal.js';
import { Entity } from '@debbie/common/dist/index.js';
import { getDirector } from '@debbie/common/dist/court/index.js';
import { SubmitStatus, SubmitToCourtError, readyToSubmit, } from '@debbie/common/dist/court/auto-submit.js';
import { GLcourts } from '@debbie/common/dist/court/countries/greenland.js';
import helpers from '@debbie/common/dist/economy/helpers/index.js';
import { VoucherCategory } from '@debbie/common/dist/economy/vouchers/index.js';
import { GLTribunalJobType, toPDFData, } from '@debbie/common/dist/tribunal/jobs/countries/greenland.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import { h } from '@debbie/cortex/dist/index.js';
import * as templatesAPI from '@debbie/cortex/dist/api/templates.js';
import { selectCaseUpdates } from '@debbie/cortex/dist/case/selectors.js';
import { selectCaseById } from '@debbie/cortex/dist/cases/selectors.js';
import { selectCustomerById } from '@debbie/cortex/dist/customers/selectors.js';
import { selectTemplates } from '@debbie/cortex/dist/templates/selectors.js';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors.js';
import { RadioSelect } from '../../../index.js';
import { APIBASE, FILEBASE } from '../../../../config.js';
import { encodeText, parseText } from '../../../../utils/templates.js';
import Alert from '../../../Alert.js';
import Button from '../../../Button.js';
import ButtonGroup from '../../../ButtonGroup.js';
import Checkbox from '../../../Checkbox.js';
import DateInput from '../../../DateInput.js';
import Errors from '../../../Errors.js';
import Input from '../../../Input.js';
import { fromHtml } from '../../../interactions/utils.js';
import Modal from '../../../Modal.js';
import MoneyInput from '../../../MoneyInput.js';
import EconomySettings from '../common/EconomySettings.js';
import ObjectComp from '../../../ObjectComp.js';
import { useCaseVouchersByCase } from '@debbie/cortex/dist/case-vouchers/index.js';
import { useInteractionsByReference } from '@debbie/cortex/dist/interactions/index.js';
import { useDocumentsByReference } from '@debbie/cortex/dist/documents/index.js';
import { useCreditor } from '@debbie/cortex/dist/creditors/index.js';
import { TemplateType } from '@debbie/common/dist/templates/index.js';
import { getMentionSuggestions } from '@debbie/common/dist/templates/suggestions.js';
import { usePropertyTypes } from '@debbie/cortex/dist/properties/index.js';
var PreviewPDF;
(function (PreviewPDF) {
    PreviewPDF[PreviewPDF["St\u00E6vning"] = 0] = "St\u00E6vning";
    PreviewPDF[PreviewPDF["Kvittering"] = 1] = "Kvittering";
    PreviewPDF[PreviewPDF["Posteringsbilag"] = 2] = "Posteringsbilag";
})(PreviewPDF || (PreviewPDF = {}));
const Staevning = (props) => {
    const lang = useSelector((s) => s.lang);
    const singleCase = useSelector((s) => selectCaseById(s, Number(props.caseSequentialId)));
    const caseVouchers_ = useCaseVouchersByCase(singleCase?.caseId);
    const caseVouchers = h.hasData(caseVouchers_) ? caseVouchers_.data : null;
    const propertyTypesLoadable = usePropertyTypes();
    const propertyTypes = h.hasData(propertyTypesLoadable)
        ? propertyTypesLoadable.data
        : undefined;
    const tenant = useSelector(selectTenant);
    const mentionSuggestions = getMentionSuggestions(lang, TemplateType.LETTER, propertyTypes || undefined, tenant);
    const creditorLoadable = useCreditor(singleCase?.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const customer = useSelector((s) => singleCase && selectCustomerById(s, singleCase.customerId));
    const caseInteractionsLoadable = useInteractionsByReference(Entity.Case, singleCase?.caseId);
    const caseInteractions = (h.hasData(caseInteractionsLoadable)
        ? caseInteractionsLoadable.data
        : []) || [];
    const caseUpdates = useSelector((s) => singleCase && selectCaseUpdates(s, singleCase.caseId));
    const documentsLoadable = useDocumentsByReference(singleCase?.caseId);
    const documents = h.hasData(documentsLoadable) ? documentsLoadable.data : null;
    const templates = useSelector(selectTemplates);
    const director = customer && getDirector(customer.users);
    const [previewPDF, setPreviewPDF] = useState(PreviewPDF.Stævning);
    const [data, setData] = useState(props.prefill
        ? {
            ...props.prefill,
            reasonEditorState: fromHtml(encodeText(props.prefill.reasoning, mentionSuggestions)),
            createdDate: moment(props.prefill.createdDate),
        }
        : {
            interestDate: moment().format('LL'),
            interests: 0,
            totalAmount: 0,
            processInterest: true,
            createdDate: moment(),
            courtFee: 50000,
            reasonEditorState: EditorState.createEmpty(),
            lawyer: localStorage.staevningLawyer ?? '',
            paralegal: localStorage.staevningParalegal ?? '',
            sendInfoToEconomyResponsible: true,
            economyResponsibleUserId: localStorage.economyResponsibleUserId ?? null,
            addCourtFeeToCase: true,
            addCourtDisbursementToClientBilling: false,
            addCourtFeeToClientBilling: false,
        });
    const [manuallyEditedAmount, setManuallyEditedAmount] = useState(false);
    const [previewModalOpen, setPreviewModalOpen] = useState(false);
    const getTotalAmount = (caseVouchers, addCourtFeeToCase) => {
        const totalAmount = -helpers.overview.balance(vouchers) +
            (addCourtFeeToCase ? data.courtFee : 0);
        return totalAmount;
    };
    useEffect(() => {
        if (caseVouchers != null && creditor != null) {
            const rawVouchers = caseVouchers;
            const vouchers = helpers.vouchers.postProcessing(rawVouchers, {
                includeDeletedVouchers: false,
                includeExpiredVouchers: false,
                includeIrrecoverableVouchers: false,
            });
            const totalAmount = getTotalAmount(caseVouchers, data.addCourtFeeToCase);
            const interests = -helpers.overview.balanceCategory(vouchers, VoucherCategory.INTEREST);
            const interestStart = vouchers
                .filter((v) => v.category === VoucherCategory.INTEREST)
                .map((v) => new Date(v.date))
                .sort()
                .map((date) => moment(date).format('LL'))[0];
            const newEditorState = EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft.default(encodeText(creditor.settings?.courtSubmitConfig?.sagsfremstilling ??
                reasonTemplate, mentionSuggestions)).contentBlocks));
            setData((s) => {
                const updateObj = props.prefill
                    ? {
                        interests: interests,
                        totalAmount: totalAmount,
                    }
                    : {
                        reasonEditorState: newEditorState,
                        interestDate: interestStart ?? s.interestDate,
                        interests: interests,
                        totalAmount: totalAmount,
                        sendInfoToEconomyResponsible: creditor?.settings.courtSubmitConfig
                            ?.sendInfoToEconomyResponsible ??
                            s.sendInfoToEconomyResponsible,
                        economyResponsibleUserId: creditor?.settings.courtSubmitConfig
                            ?.economyResponsibleUserId ?? s.economyResponsibleUserId,
                        addCourtDisbursementToClientBilling: creditor?.settings.courtSubmitConfig
                            ?.addCourtDisbursementToClientBilling ??
                            s.addCourtDisbursementToClientBilling,
                        addCourtFeeToClientBilling: creditor?.settings.courtSubmitConfig
                            ?.addCourtFeeToClientBilling ?? s.addCourtFeeToClientBilling,
                    };
                return {
                    ...s,
                    ...updateObj,
                };
            });
        }
    }, [caseVouchers, creditor]);
    const vouchers = caseVouchers != null
        ? helpers.vouchers.postProcessing(caseVouchers, {
            includeDeletedVouchers: false,
            includeExpiredVouchers: false,
            includeIrrecoverableVouchers: false,
        })
        : [];
    const getData = () => {
        return {
            interestDate: data.interestDate,
            interests: data.interests,
            totalAmount: data.totalAmount,
            processInterest: data.processInterest,
            createdDate: data.createdDate.format('LL'),
            courtFee: data.courtFee,
            reasoning: parseText(draftToHtml(convertToRaw(data.reasonEditorState.getCurrentContent())), mentionSuggestions),
            lawyer: data.lawyer,
            paralegal: data.paralegal,
            director: director,
            courtId: GLcourts[0].courtId,
            invoiceFileIds: vouchers
                .filter((v) => v.appendix)
                .map((v) => v.appendix.fileId),
            sendInfoToEconomyResponsible: data.sendInfoToEconomyResponsible,
            economyResponsibleUserId: data.economyResponsibleUserId,
            addCourtFeeToCase: data.addCourtFeeToCase,
            addCourtDisbursementToClientBilling: data.addCourtDisbursementToClientBilling,
            addCourtFeeToClientBilling: data.addCourtFeeToClientBilling,
            isGreenland: true,
        };
    };
    const submitter = useMutation(async () => {
        if (!singleCase) {
            throw Error('Case not loaded');
        }
        const data = getData();
        await tribunalAPI.createTribunalJob({
            type: props.resending
                ? GLTribunalJobType.ResendStaevning
                : GLTribunalJobType.CreateStaevning,
            tribunalCaseId: props.tribunalCaseId,
            data: data,
            caseId: singleCase.caseId,
            reference: null,
        });
    }, {
        onSuccess: () => {
            if (props.onCreated) {
                props.onCreated();
            }
        },
    });
    const submittable = singleCase &&
        creditor &&
        caseVouchers &&
        customer &&
        caseUpdates &&
        documents &&
        templates &&
        tenant &&
        readyToSubmit({
            creditor,
            caseVouchers,
            customer,
            documents,
            interactions: caseInteractions,
            updates: caseUpdates,
            templates,
            tenant,
        }, {
            ...creditor.settings.courtSubmitConfig,
            incluededRules: [
                SubmitToCourtError.CaseHasDeposits,
                SubmitToCourtError.MoreThanOneDebtor,
                SubmitToCourtError.HasAlternativeContact,
                SubmitToCourtError.CurrencyNotDKK,
                SubmitToCourtError.ExcessiveCollectionCostImposed,
                SubmitToCourtError.ExcessiveCollectionFeeImposed,
                SubmitToCourtError.AlreadyInCourt,
                SubmitToCourtError.CaseHasExceededMaxDebtRegistrationsThreshold,
                SubmitToCourtError.ExcessivePrincipal,
            ],
        });
    const canSubmit = data.lawyer != '' &&
        data.paralegal != '' &&
        // data.interestDate != '' &&
        (data.sendInfoToEconomyResponsible
            ? data.economyResponsibleUserId != null
            : true) &&
        submittable &&
        submittable.status !== SubmitStatus.No;
    return (React.createElement("div", null,
        submittable &&
            submittable.errors.map((error) => (React.createElement(Alert, { message: lang.courtSubmitErrors[error], size: "small", key: error }))),
        React.createElement("h3", null, "Deltagere"),
        React.createElement(Input, { placeholder: "Advokat", onChange: (e) => {
                const val = e.currentTarget.value;
                setData((s) => ({ ...s, lawyer: val }));
                localStorage.setItem('staevningLawyer', val);
            }, value: data.lawyer }),
        React.createElement(Input, { placeholder: "Advokat fuldm\u00E6gtig", onChange: (e) => {
                const val = e.currentTarget.value;
                setData((s) => ({ ...s, paralegal: val }));
                localStorage.setItem('staevningParalegal', val);
            }, value: data.paralegal }),
        React.createElement("h3", null, "Rubrik 3"),
        React.createElement(MoneyInput, { placeholder: "Rentebel\u00F8b", onChange: (val) => {
                setData((s) => ({ ...s, interests: val }));
            }, value: data.interests }),
        React.createElement(MoneyInput, { placeholder: "Bel\u00F8b i alt", onChange: (val) => {
                setManuallyEditedAmount(true);
                setData((s) => ({ ...s, totalAmount: val }));
            }, value: data.totalAmount }),
        React.createElement(Checkbox, { placeholder: "Processrente", checked: data.processInterest, onChange: (e) => {
                const val = e.currentTarget.checked;
                setData((s) => ({ ...s, processInterest: val }));
            } }),
        React.createElement(Editor, { stripPastedStyles: true, editorState: data.reasonEditorState, onEditorStateChange: (editorState) => {
                setData((s) => ({ ...s, reasonEditorState: editorState }));
            }, mention: {
                separator: ' ',
                trigger: '@',
                suggestions: mentionSuggestions.map((suggestion) => ({
                    value: suggestion.label,
                    text: suggestion.label,
                    url: suggestion.label,
                })),
            } }),
        React.createElement("h3", null, "Rubrik 5"),
        React.createElement(EconomySettings, { customizableCourtFee: true, value: data, onChange: (es) => {
                if (es.addCourtFeeToCase != null &&
                    !manuallyEditedAmount &&
                    caseVouchers != null) {
                    setData((s) => ({
                        ...s,
                        ...es,
                        totalAmount: getTotalAmount(caseVouchers, es.addCourtFeeToCase),
                    }));
                }
                else {
                    setData((s) => ({ ...s, ...es }));
                }
            } }),
        React.createElement("h3", null, "Rubrik 6"),
        React.createElement(DateInput, { placeholder: "Oprettelsesdato", allowNull: false, value: data.createdDate, onChange: (d) => {
                setData((s) => ({ ...s, createdDate: d }));
            } }),
        submitter.isError && submitter.error instanceof Error && (React.createElement(Errors, { errors: [submitter.error.message] })),
        React.createElement("div", null,
            React.createElement(ButtonGroup, null,
                React.createElement(Button, { size: "small", onClick: () => {
                        submitter.mutate();
                    }, disabled: !canSubmit, loading: submitter.isLoading }, "Send"),
                React.createElement(Button, { size: "small", theme: "secondary", disabled: !canSubmit, onClick: () => {
                        setPreviewModalOpen(true);
                    } }, "Forh\u00E5ndsvisning"))),
        previewModalOpen && (React.createElement(Modal, { header: lang.documents.preview, onToggle: () => setPreviewModalOpen(false) }, props.caseSequentialId && singleCase ? (React.createElement(React.Fragment, null,
            React.createElement("div", null,
                React.createElement(RadioSelect, { active: previewPDF === PreviewPDF.Stævning, onClick: () => setPreviewPDF(PreviewPDF.Stævning), label: "St\u00E6vning" }),
                React.createElement(RadioSelect, { active: previewPDF === PreviewPDF.Kvittering, onClick: () => setPreviewPDF(PreviewPDF.Kvittering), label: "Kvittering" }),
                !!vouchers.filter((v) => v.appendix).length && (React.createElement(RadioSelect, { active: previewPDF === PreviewPDF.Posteringsbilag, onClick: () => setPreviewPDF(PreviewPDF.Posteringsbilag), label: "Posteringsbilag" }))),
            React.createElement("br", null),
            previewPDF === PreviewPDF.Stævning && (React.createElement(ObjectComp, { type: "application/pdf", url: `${APIBASE}/templates/file${templatesAPI.genLetterUrl('42f7bfc6-f373-44c9-8707-1282aca808d6', // Staevning template
                singleCase.caseId, toPDFData(getData()), `Stævning`)}` })),
            previewPDF === PreviewPDF.Kvittering && (React.createElement(ObjectComp, { type: "application/pdf", url: `${APIBASE}/templates/file${templatesAPI.genLetterUrl('94777afd-e545-4cbe-a384-394710852f45', // Kvittering template
                singleCase.caseId, toPDFData(getData()), `Kvittering`)}` })),
            previewPDF === PreviewPDF.Posteringsbilag &&
                vouchers
                    .filter((v) => v.appendix)
                    .map((v) => (React.createElement(ObjectComp, { key: v.id, type: "application/pdf", url: `${FILEBASE}/${v.appendix.fileId}/${v.appendix.fileName}` }))))) : (React.createElement("h3", { style: {
                margin: '4em 0',
                opacity: 0.7,
                textAlign: 'center',
            } }, lang.templates.selectTestCase))))));
};
const reasonTemplate = `
<p>Beløbet skyldes for:</p>
<br>
<p>Fakturadato – Fakturanr. – Procesrente opgjort til d.d.:</p>
<br>
{{principalsWithInterestsList}}
<br>
<p>Da sagsøgte trods påkrav ikke har betalt beløbet, har nærværende sagsanlæg været nødvendig. Det forventes ikke, at sagsøgte har indsigelser mod kravet eller vil gøre modkrav gældende.</p>
<br>
<p>Herudover er der indbetalt kr. {{formattedFields.financials.depositedToCreditor}} direkte til kreditor samt kr. {{formattedFields.financials.depositedToCollector}} til undertegnede, efter sagen er overgivet til inkasso.</p>
<br>
<p>I rubrik A er der opgjort allerede påløbne fra de enkelte fakturaer i henhold til rentelovens § 3, stk. 2 og der søges herefter renter fra stævningens indlevering, jf. rentelovens § 3, stk. 4.</p>
`;
export default Staevning;
//# sourceMappingURL=Staevning.js.map